<!-- @format -->

@if (courseUnitRealisation) {
  @if (courseUnitRealisation.tweetText) {
    <p class="key-text">
      {{ courseUnitRealisation.tweetText | localizedString }}
    </p>
  }
  <div class="mb-5 mb-sm-3">
    <sis-tab-content-switch
      [(currentIndex)]="currentTabIndex"
      type="pills"
      [tabs]="[
        { title: 'OPEN_UNIVERSITY.STUDY_OFFERING.CUR_INFO.STUDY_GROUPS_AND_EVENTS' },
        { title: 'OPEN_UNIVERSITY.STUDY_OFFERING.CUR_INFO.BASIC_INFO' },
      ]">
    </sis-tab-content-switch>
  </div>
  <div [hidden]="currentTabIndex !== 0">
    @for (studyGroupSet of courseUnitRealisation.studyGroupSets; track entityId($index, studyGroupSet)) {
      <div class="row">
        <div class="col-12">
          <div class="fudis-heading__xs" role="heading" [attr.aria-level]="7">{{ studyGroupSet.name | localizedString }}</div>
          @if (!hideGuidance) {
            <p class="sis-guidance">{{ studyGroupSet | allocationRuleDescription: "OPEN_UNIVERSITY.STUDY_OFFERING.SELECTION_RULE" }}</p>
          }
          <sis-description-list [columnCount]="1">
            <dl>
              @for (studySubGroup of studyGroupSet.studySubGroups; track entityId($index, studySubGroup)) {
                <ng-template #listItem>
                  @if (!studySubGroup.cancelled) {
                    <dt class="sis-label">{{ studySubGroup.name | localizedString }}</dt>
                    <dd>
                      <app-study-event-info-list
                        [studyEvents]="studySubGroup.studyEventIds | studyEvents | async"
                        [teacherIds]="studySubGroup.teacherIds"></app-study-event-info-list>
                    </dd>
                  }
                </ng-template>
              }
            </dl>
          </sis-description-list>
        </div>
      </div>
    }
  </div>
  <app-course-unit-realisation-basic-info
    [hidden]="currentTabIndex !== 1"
    [courseUnitRealisation]="courseUnitRealisation"
    [courseUnitId]="courseUnitId"></app-course-unit-realisation-basic-info>
}
